// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PercentageOutlinedSvg from "@ant-design/icons-svg/es/asn/PercentageOutlined";
import AntdIcon from '../components/AntdIcon';

var PercentageOutlined = function PercentageOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PercentageOutlinedSvg
  }));
};

PercentageOutlined.displayName = 'PercentageOutlined';
export default React.forwardRef(PercentageOutlined);